"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NULL_ACTION = {
  type: null
};
exports.default = NULL_ACTION;